<template>

    <div class="dropdown" ref="dropdownRef">

        <button 
            class="btn btn-outline-secondary btn-sm dropdown-toggle" 
            :class="props.css"
            href="#" 
            role="button" 
            data-bs-toggle="dropdown"
            aria-expanded="false"
            @click="toggleMenu($event)"
        >
            <span v-if="props.placeholder" v-html="props.placeholder"></span>
            <span v-else>Choose Options</span>
        </button>

        <ul class="dropdown-menu show px-2" 
            v-if="showMenu" 
            style="max-height: 300px; overflow-y:scroll; right: 0;"
        >
            <li v-for="(row, i) in props.options">
                <hr class="dropdown-divider" v-if="row == 'divider'">
                <div class="form-check">
                    <input
                        :id="'multi-' + i"
                        :ref="inputs['c' + i]"
                        class="form-check-input" 
                        type="checkbox" 
                        v-model="innerModel['c' + i]"
                    />
                    <label 
                        class="form-check-label" 
                        :for="'multi-' + i"
                    >
                        <span>{{ (props.labelKey && typeof row !== 'string' ? row[props.labelKey] : row) || 'Not Provided' }}</span>
                    </label>
                </div>
            </li>
        </ul>

    </div>
</template>


<script lang="ts" setup>

import { ref, watch, onMounted, onUnmounted } from "vue";

const inputs = ref<Record<string, any>>({});
const innerModel = ref<Record<string, boolean>>({});
const unwatch:Array<Function> = [];
const dropdownRef = ref<HTMLElement | null>(null);

const showMenu = ref(false);

const model = defineModel({
    type: Array<string | number>,
    default: []
});

const props = defineProps({
    
    options: {
        type: Array<string | Record<string, any>>,
        default: []
    },
    
    css: {
        type: String,
        default: "",
    },
    
    placeholder: {
        type: String,
        default: "",
    },
    
    labelKey: {
        type: String,
        default: "",
    },

    valueKey: {
        type: String,
        default: "",
    },

});

const toggleMenu = (event:Event) =>
{
    event.stopImmediatePropagation();
    event.preventDefault();
    showMenu.value = !showMenu.value;
    console.debug("select", model.value);
};

let skipWatch = false;

const watchInnerModel = (nv:any, ov:any) =>
{
    let tmp:Array<string | number> = [];

    for (let p in innerModel.value)
    {
        if (!innerModel.value[p])
        {
            continue;
        }

        // remove the 'c' character ...
        let index = Number(p.substring(1));
        let row = props.options[index];
        let val:string = "";

        // grab the value from the options ...
        if (props.valueKey && typeof row !== 'string')
        {
            val = row[props.valueKey];
        }

        else
        {
            val = (row + "");
        }

        tmp.push(val);
    }

    skipWatch = true;
    model.value = tmp;
};

const watchExternalModel = (nv:any, ov:any) =>
{
    // if the model is updated check the right elements ...
    if (skipWatch)
    {
        skipWatch = false;
        return;
    }

    // an edit came from external ... set the internal model properly
    let tmp:Record<string, any> = {};
    for (let i = 0; i < props.options.length; i++)
    {
        let row = props.options[i];
        // alert(row.Id);

        for (let j = 0; j < model.value.length; j++)
        {
            let xv = model.value[j];
            
            if (props.valueKey && typeof row !== 'string')
            {

                if (row[props.valueKey] == xv)
                {
                    // check the right box ...
                    tmp["c" + i] = true;
                }
            }
            
            else if (row == xv)
            {
                tmp["c" + i] = true;
            }
        }
    };

    innerModel.value = tmp;
};

// kind of ugly ... is there a better way to do this?

// watch for external changes ...
unwatch.push(watch(() => JSON.stringify(model.value), watchExternalModel, {
    immediate: true
}));

// watch for internal changes ...
unwatch.push(watch(() => JSON.stringify(innerModel.value), watchInnerModel));

// watch for option changes ...
unwatch.push(watch(() => JSON.stringify(props.options), (nv, ov) => {
    watchExternalModel(props.options, props.options);
}));

const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
        showMenu.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() =>
{
    document.removeEventListener('click', handleClickOutside);
    unwatch.forEach((un) => {
        un();
    });
});

</script>